import React, { useState } from 'react';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import CommonImage from '@/components/CommonImage';
import { toastError, toastSuccess } from '@/components/Toast';
import useSingleFileUpload from '@/hooks/useSingleFileUpload';
import LoaderComponent from '@/components/LoaderComponent';

import { useCreateDevelopedProductMutation } from '../api/supplierConfigurationApi';

const DevelopedProductAddModal = ({ onClose, categorySubCategoryList, supplierId }) => {
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectMultipleFiles, setSelectMultipleFiles] = useState([]);
	const { readFile } = useSingleFileUpload();

	const [createDevelopedProduct, { isLoading }] = useCreateDevelopedProductMutation();

	const handlesubmit = async () => {
		if (!selectedCategory?.id) {
			toastError('Please select a category');
			return;
		}

		if (!selectMultipleFiles?.length) {
			toastError('Please upload at least one image');
			return;
		}

		try {
			const body = await Promise.all(
				selectMultipleFiles.map(async (file) => {
					const base64Str = await readFile(file);
					return {
						documentDTO: {
							name: file?.name,
							base64Str,
							docMimeType: file?.type || 'image/jpeg',
							documentType: 'SUPPLIER_MANUFACTURED_DESIGN'
						}
					};
				})
			);

			await createDevelopedProduct({
				id: supplierId,
				subCategoryId: selectedCategory.id,
				body
			}).unwrap();

			toastSuccess('Added successfully');
			onClose();
		} catch (error) {
			toastError(error?.data?.message || 'Something went wrong');
		}
	};

	const multipleFileUpload = (event) => {
		const files = Array.from(event.target.files || []);
		setSelectMultipleFiles((prevFiles) => [...prevFiles, ...files]);
		event.target.value = null;
	};
	const handleItemFileRemove = (index) => {
		const deleteFile = selectMultipleFiles.filter((item, i) => i !== index);
		setSelectMultipleFiles(deleteFile);
	};

	const handleCategoryList = (list) => {
		return (list || []).flatMap((item) =>
			(item?.subCategoryResponseList || []).map((subCategory) => ({
				id: subCategory.id,
				value: subCategory.name,
				isPrimary: subCategory.isPrimary
			}))
		);
	};
	const handleItemClick = (item) => {
		setSelectedCategory(item || null);
	};
	return (
		<LoaderComponent loading={isLoading}>
			<ModalContainer className="gallery-modal-main">
				<div className="common-popup gallery-modal">
					<ModalHeader title={`Add Product`} onClose={onClose} />
					<div className="common-popup-body">
						<div className="row">
							<div className="col-md-12">
								<div className="gallery-upload-and-items">
									<div className="single-item mb-2">
										<div className="upload-section">
											<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
												<label className="drag-upload m-0" htmlFor="drag-upload" />
												<input
													accept="image/*"
													className="file-upload"
													name="image"
													type="file"
													multiple
													id="drag-upload"
													onChange={multipleFileUpload}
												/>
											</div>
										</div>
									</div>
									{selectMultipleFiles?.map((file, index) => {
										return (
											<div
												key={index}
												className="single-item position-relative w-100 ml-2"
											>
												<div className="image">
													<img
														src={URL.createObjectURL(file)}
														alt="edit"
														className="style-photo"
													/>
													<div className="action-icon  cursor-pointer">
														<CommonImage
															width="20px"
															src="/icons/delete_gray.svg"
															alt="check"
															className="cursor-pointer"
															onClick={() => handleItemFileRemove(index)}
														/>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Add Type</label>
										<CustomDropdown
											type="addItem"
											title={'Category'}
											isAddNew={false}
											onItemClick={handleItemClick}
											items={handleCategoryList(categorySubCategoryList)}
											selectedItem={selectedCategory?.value}
										/>
									</div>
									{/* {errors?.categoryError && <p className="error">{errors.categoryError}</p>} */}
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button gray-outline size32" onClick={onClose}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								onClick={handlesubmit}
								disabled={isLoading}
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</ModalContainer>
		</LoaderComponent>
	);
};

export default DevelopedProductAddModal;
